import { render, staticRenderFns } from "./rare.vue?vue&type=template&id=23089676"
import script from "./rare.vue?vue&type=script&lang=js"
export * from "./rare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports